
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/events/[friendlyUrl]",
      function () {
        return require("private-next-pages/events/[friendlyUrl].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/events/[friendlyUrl]"])
      });
    }
  